module.exports = __webpack_public_path__ + "static/media/1011048.6b3e721b.jpg";